import { generatePath, useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../utils/pathParamTypes'

export const MERGE_ROUTE_PATH =
  `/merge/:survivorPid(${pidRegexStr as PID})/:duplicatePid(${pidRegexStr as PID})` as const

// The old three-step merge flow put a step segment in the URL. Bookmarks, help-center articles and
// emails still link to it, so these URLs redirect to MERGE_ROUTE_PATH (see LegacyMergeStepRedirect).
// TODO(TREEWEB-12557): remove legacy merge step URL redirect after 2027-11-30
export const LEGACY_MERGE_ROUTE_PATH =
  `/merge/:mergeStep(verify|compose|confirm)/:survivorPid(${pidRegexStr as PID})/:duplicatePid(${pidRegexStr as PID})` as const

type MergeRouteParams = PathParamMap<typeof MERGE_ROUTE_PATH>

export const useMergeParams = (): MergeRouteParams => useParams<MergeRouteParams>()

export const getMergeUrl = ({ duplicatePid, survivorPid }: MergeRouteParams): string =>
  generatePath(MERGE_ROUTE_PATH, { duplicatePid, survivorPid })
